import React from 'react';
import PropTypes from 'prop-types';
import {action, autorun, observable, runInAction} from 'mobx';
import {inject, observer} from 'mobx-react';
import {routerShape, withRouter} from 'react-router';
import * as Sentry from '@sentry/react';
import { BOOKING_BASE_URL } from 'utils/constants';

import {withConfig, withI18n} from 'spa/Components/Context';
import autobind from 'autobind-decorator';
import isValidException from 'utils/isValidException';

import ImageTitleSubtextBox from '@urbanmassage/component-library/lib/ImageTitleSubtextBox/ImageTitleSubtextBox';
import AddressValidation from '../Components/AddressValidation';
import BookingLayout from '../Components/BookingLayout';
import CategoryBoxLoading from '../Components/CategoryBoxLoading';

import './category-screen.less';

@withRouter
@inject(({
  store: {
    categories,
    tracker,
  },
}) => (
  {
    categories,
    tracker,
  }
))
@observer
@withI18n
@withConfig
class CategoryScreen extends React.Component {
  static propTypes = {
    categories: PropTypes.shape({
      getV4CategoriesContent: PropTypes.shape({
        load: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
    router: routerShape.isRequired,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
  }

  // constructor(props /*context*/) {
  //   super(props);
  //   const {config, i18n} = context;

  //   // TODO this will now not work as it uses category ID's - we only get stubs back - should move config values to stubs imo more readable in config and less data here
  //   this.disabledCategories = config.getValue('locale.b2c.disabled-booking-categories', i18n.umRegion);
  // }

  componentDidMount() {
    this.listeners = [
      autorun(() => {
        this.isLoading = true;
        this.onGetCategories();
      }),
    ];
  }

  componentWillUnmount() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }

  @observable categories = [];
  @observable isLoading = false;

  @autobind
  @action('onSelectCategory - SelectCategory')
  onSelectCategory(stubVal) {
    const {i18n} = this.context;
    const {router, tracker} = this.props;

    if (this.categories) {
      const category = this.categories.find(cat => cat.stub === stubVal);

      // TODO LEAVE THIS HERE AS WE NEED TO COMMUNICATE EVENT CHANGES
      tracker.track('Selected Category', {
        category: 'Booking',
        stub: category.stub,
        label: category.stub,
        // category_id: category.id,
      //   city_id: id,
      //   isPreLaunch: !!event.currentTarget.dataset.isPreLaunch,
      //   serviceArea_id: this.serviceAreaId,
      });

      router.push(`/${i18n.lc}/${BOOKING_BASE_URL}/services/${category.stub}`);
    }
  }

  @autobind
  @action('onGetCategories - SelectCategory')
  onGetCategories() {
    this.props.categories.getV4CategoriesContent.load('', {
      appointment_id: 'active',
    })
      .then((res) => {
        runInAction(() => {
          // TODO see above
          // this.categories = res.categories.filter(category => this.disabledCategories.indexOf(category.id) === -1);
          this.categories = res.categories;

          if (!this.categories.length) {
            Sentry.captureMessage('Categories loading 0 results');
          }

          this.isLoading = false;
        });
      }).catch((err) => {
        runInAction(() => {
          if (__DEV__) {
            console.error(err);
          }
          // TODO show this error to the user?
          // This is unexpected so record it in Sentry
          if (isValidException(err)) {
            Sentry.captureException(err);
          } else {
            Sentry.captureMessage('CategoryScreen - unhandled error loading categories content and sub categories');
          }
          this.isLoading = false;
        });
      });
  }

  render() {
    const {i18n} = this.context;
    const {
      categories,
      isLoading,
      onSelectCategory,
      onGetCategories,
    } = this;

    return (
      <BookingLayout
        title={i18n._x('Choose service', 'Booking Flow')}
        trackingCategory="Booking"
      >
        <AddressValidation
          onUseAddress={onGetCategories}
          loadingScreen={
            <div className="container category-screen">
              <CategoryBoxLoading />
            </div>
          }>
          <div className="container category-screen">
            {isLoading ? (
              <CategoryBoxLoading />
            ) : (
              <div className="category-screen__container">
                {/* {!categories || !categories.length} {
                  <div>TODO CATEGORIES MISSING ERROR SCREEN</div> // TODO - handle with a booking wide error state
                } */}
                {categories && categories.map(category => (
                  <ImageTitleSubtextBox
                    data-test-group="category-image-title"
                    data-category-stub={category.stub}
                    data-qa={`category-select-${category.stub}`}
                    key={`category-${category.stub}`}
                    onClick={() => onSelectCategory(category.stub)}
                    image={category.imageUrl}
                    imageAlt={category.name}
                    title={category.name}
                    subtext={category.shortDescription}
                  />
                ))}
              </div>
            )}
          </div>
        </AddressValidation>
      </BookingLayout>
    );
  }
}

export default CategoryScreen;



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/CategoryScreen/CategoryScreen.jsx